import React from 'react';
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom';
import Dashboard from './pages/Dashboard';
import ProjectAnalysis from './pages/ProjectAnalysis';
import AdminUsers from './pages/AdminUsers';
import AdminStudies from './pages/AdminStudies';
import Login from './pages/Login';
import ProtectedRoute from './components/common/ProtectedRoute';
import authService from './services/authService';
import { updateDocumentBranding } from './utils/branding';

updateDocumentBranding();

function App() {
  return (
    <Router>
      <Switch>
        <Route exact path="/login">
          {authService.isAuthenticated() ? <Redirect to="/" /> : <Login />}
        </Route>
        
        <Route exact path="/">
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        </Route>
        
        <Route path="/projets/:studyId">
          <ProtectedRoute>
            <ProjectAnalysis />
          </ProtectedRoute>
        </Route>
        
        <Route path="/admin/users">
          <ProtectedRoute requireAdmin>
            <AdminUsers />
          </ProtectedRoute>
        </Route>
        
        <Route path="/admin/studies">
          <ProtectedRoute requireAdmin>
            <AdminStudies />
          </ProtectedRoute>
        </Route>
        
        <Route path="*">
          <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
            flexDirection: 'column',
            gap: '16px'
          }}>
            <h1>404 - Page non trouvée</h1>
            <a href="/" style={{ color: 'var(--color-primary)' }}>
              Retour au tableau de bord
            </a>
          </div>
        </Route>
      </Switch>
    </Router>
  );
}

export default App;
